
import Vue from 'vue'
import Component, { mixins } from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import Mixin from '../../mixin'
import { db, storageRef } from '@/main'
import firebase from 'firebase'
import DialogAddDiscount from '@/components/discount/DialogAddDiscount.vue'
import Axios from 'axios'
import VueExcelXlsx from 'vue-excel-xlsx'
import DialogPremium from "@/components/users/DialogPremium.vue"

Vue.use(VueExcelXlsx)
let app
@Component({
  components: {
    DialogAddDiscount,
    DialogPremium
  },
})
export default class ClientProfile extends mixins(Mixin) {
  currentYear = new Date().getFullYear()
  reportedVagises = 0
  registeredMustDoIts = 0
  registeredLifeProjects = 0
  searchMust = ''
  searchReport = ''
  searchLife = ''
  user: any = {}
  UID
  itemsPerPage = 3
  page = 1
  coupons = []
  isEditing = false
  states: any[] = []
  cities: any[] = []
  mustDoItList: any[] = []
  lifeProjectList: any[] = []
  center = { lat: 9.929405, lng: -84.091424 }
  markerPosition = { lat: 9.929405, lng: -84.091424 }
  active_tab = 0
  mainImage: File = new File([''], '')
  image1: File = new File([''], '')
  image2: File = new File([''], '')
  image3: File = new File([''], '')
  stateRules = [
    (v) => (v != undefined ? !!v || 'El departamento es obligatorio' : ''),
  ]
  cityRules = [(v) => (v != undefined ? !!v || 'La ciudad es obligatoria' : '')]
  addressRules = [
    (v) => (v != undefined ? !!v || 'La dirección es obligatoria' : ''),
    (v) =>
      v != undefined
        ? v.length > 5 || 'La dirección debe tener mas de 5 caracteres'
        : '',
  ]
  rulesImage = [
    (v) => (v != undefined ? !!v || 'La imagen es obligatorio' : ''),
    (v) =>
      !v ||
      v.size < 7000000 ||
      'El tamaño de la imagen debe ser menor de 7 MB!',
  ]

  mustHeaders = [
    { text: 'Categoría', value: 'category_name' },
    { text: 'Fecha inicio', value: 'start_date' },
    { text: 'Fecha fin', value: 'end_date' },
    { text: 'Completado', value: 'completed' },
  ]

  LifeHeaders = [
    { text: 'Categoría', value: 'category_name', align: 'start' },
    { text: 'Intervalo', value: 'interval_name' },
    { text: 'Fecha inicio', value: 'start_date' },
    { text: 'Fecha fin', value: 'end_date' },
    { text: 'Completado', value: 'completed' },
  ]

  columnsExcelMust: any = []
  columnsExcelLife: any = []

  async mounted() {
    this.UID = this.$route.params.id
    this.mustDoItList = []
    this.lifeProjectList = []
    db.collection('users')
      .doc(this.UID)
      .onSnapshot((doc) => {
        console.log(doc.data())
        this.user = doc.data()
        this.user["uid"] = doc.id
        console.log(this.user)
      })

    await db
      .collection('users')
      .doc(this.UID)
      .collection('must_do_it')
      .where('year', '==', this.currentYear)
      .get()
      .then((querySnapshot) => {
        this.registeredMustDoIts = querySnapshot.size
        querySnapshot.forEach((doc) => {
          const mustDoItData = doc.data()
          mustDoItData['start_date'] = this.formatDateWithHour(
            mustDoItData['start'].toDate()
          )
          mustDoItData['end_date'] = this.formatDateWithHour(
            mustDoItData['end'].toDate()
          )
          this.mustDoItList.push(mustDoItData)
        })
      })

    await db
      .collection('users')
      .doc(this.UID)
      .collection('life_projects')
      .where('year', '==', this.currentYear)
      .get()
      .then((querySnapshot) => {
        this.registeredLifeProjects = querySnapshot.size
        querySnapshot.forEach((doc) => {
          const lifeProjectData = doc.data()
          lifeProjectData['start_date'] = this.formatDateWithHour(
            lifeProjectData['start'].toDate()
          )
          lifeProjectData['end_date'] = this.formatDateWithHour(
            lifeProjectData['end'].toDate()
          )

          lifeProjectData['interval_name'] =
            lifeProjectData['interval'] == 'Custom'
              ? 'Personalizado'
              : lifeProjectData['interval'] == 'Weekly'
              ? 'Semanal'
              : 'Diario'

          this.lifeProjectList.push(lifeProjectData)
        })
      })

    await db
      .collection('users')
      .doc(this.UID)
      .collection('reports')
      .doc(this.currentYear.toString())
      .collection('vagis')
      .get()
      .then((querySnapshot) => {
        this.reportedVagises = querySnapshot.size
        console.log('UserVagises:' + querySnapshot.size)
      })
    this.getColumnsExcel()
  }

  getColumnsExcel() {
    try {
      let mapToAdd
      this.mustHeaders.forEach((header) => {
        mapToAdd = {
          label: header['text'],
          field: header['value'],
        }

        this.columnsExcelMust.push(mapToAdd)
      })

      let mapToAdd2
      this.LifeHeaders.forEach((header) => {
        mapToAdd2 = {
          label: header['text'],
          field: header['value'],
        }

        this.columnsExcelLife.push(mapToAdd2)
      })
    } catch (error) {
      console.log('Error getColumnsExcel ' + error)
    }
  }

  async uploadImage(fieldRef, file) {
    try {
      this.showNotification('loading', 'Subiendo imagen', file.name)
      const uploadTask = await storageRef
        .child(
          '/clients/' +
            this.UID +
            '/fields' +
            '/' +
            fieldRef +
            '/images/' +
            file.name
        )
        .put(file)
      const downloadURL = await uploadTask.ref.getDownloadURL()
      console.log('downloadURL: ' + downloadURL)
      return downloadURL
    } catch (error) {
      console.log(error)
      app.showNotification(
        'fail',
        'Error',
        'Ocurrió un error al subir la imagen'
      )
    }
  }
  async editUser() {
    console.log(this.user)
    db.collection('users')
      .doc(this.UID)
      .update(this.user)
      .then(() => {
        this.showNotification(
          'success',
          'Información modificada',
          'La información del usuario fue modificada con éxito'
        )
        this.isEditing = !this.isEditing
      })
      .catch((error) => {
        this.showNotification(
          'fail',
          'Error',
          'Ocurrió un error al modificar la información del usuario'
        )
        console.log(error)
      })
  }

  getCategoryColor(category) {
    if (category == 'Profesión & Trabajo' || category == 'Profession & Work') {
      return 'red'
    } else if (category == 'Finanzas' || category == 'Finances') {
      return 'green'
    } else if (
      category == 'Social & Friends' ||
      category == 'Social & Amigos'
    ) {
      return 'blue'
    } else if (
      category == 'Ocio & Recreación' ||
      category == 'Leisure & Recreation'
    ) {
      return 'yellow'
    } else if (
      category == 'Salud & Fitness' ||
      category == 'Health & Fitness'
    ) {
      return 'green accent-2'
    } else if (
      category == 'Espiritualidad & contribución' ||
      category == 'Spirituality & Contribution'
    ) {
      return 'blue'
    } else if (category == 'Aprendizaje' || category == 'Learning') {
      return 'indigo accent-4'
    } else if (category == 'Love' || category == 'Amor') {
      return 'pink'
    } else if (category == 'Family' || category == 'Familia') {
      return 'deep-blue'
    }
  }
}
